import { createIcon } from '../createIcon';

export const PortIconConfig = {
  name: 'PortIcon',
  height: 1024,
  width: 960,
  svgPath: 'M385.2,430.2 C382.8,423.7 373.8,423.2 370.6,429.3 L264.8,631.8 C262,637.1 256.6,640 250.6,640 L0,640 L0,512 L177.9,512 C180.9,512 183.6,510.6 185,508 L377.4,139.7 C381.4,132 387.7,128 395.4,128 C403.1,128 410.8,133.9 413.9,141.9 L588.1,606.7 C590.5,613 599,613.7 602.5,608 L731.7,392.5 C734.6,387.7 739.8,384 745.4,384 L960,384 L960,512 L813.4,512 C810.6,512 808,514.2 806.5,516.6 L584.2,887.2 C581,892.5 576.4,896 570.2,896 C564,896 558,891.3 555.5,884.6 L385.2,430.2 Z',
  yOffset: 0,
  xOffset: 0,
};

export const PortIcon = createIcon(PortIconConfig);

export default PortIcon;